export const setSocket = (payload) => {
  return {
    type: 'SET_SOCKET',
    payload,
  }
}
